// Função utilitária para envio de feedback
// Implemente aqui a lógica real de envio (ex: API, email, etc)

export async function sendFeedback({ type, message, image }) {
  // URL da API - funciona tanto local quanto no Vercel
  const apiUrl = process.env.NODE_ENV === 'production' 
    ? '/api/feedback'  // Vercel Functions
    : 'http://localhost:3002/api/feedback'; // Desenvolvimento local

  let response;

  if (image) {
    // Se tem arquivo, usar FormData
    const formData = new FormData();
    formData.append('type', type);
    formData.append('message', message);
    formData.append('file', image);

    response = await fetch(apiUrl, {
      method: 'POST',
      body: formData,
    });
  } else {
    // Se não tem arquivo, usar JSON
    const data = { type, message };

    response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }

  if (!response.ok) {
    // Capturar mais detalhes do erro
    const errorText = await response.text();
    console.error('Erro na API:', response.status, errorText);
    throw new Error(`Erro ao enviar feedback: ${response.status} - ${errorText}`);
  }
  return true;
}
